@if (control.errors && control.touched) {
  <ul>
    @for (error of control.errors | keyvalue; track error.key) {
      <li style="color: red">
        {{ getErrorMessage(error.key, error.value) }}
      </li>
    }
  </ul>
}
